import React from "react";
import moment from "moment";

import Amendments from "./Amendments";
import AuditClientAndReport from "./AuditClientAndReport";
import ResponsibilityNotDivided from "./ResponsibilityNotDivided";
import ResponsibilityDivided from "./ResponsibilityDivided";

import { getField, padZerosToString, formatDate } from "../../../../util/DynamicItemUtils";

export default function FormAPFilingDetails({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ss";

  const issuerName = getField(item, "issuername");
  const issuerTicker = getField(item, "issuerticker");
  const issuerCikExists = !(getField(item, "issuerciknone") === "True");
  const issuerCik = getField(item, "issuercik");

  const engagementLink =
    "/resources/auditorsearch/engagement-partners/?engagementpartnermasterid=" +
    getField(item, "engagementpartnermasterid");
  const firmLink =
    "/resources/auditorsearch/firms/?firmid=" + getField(item, "firmid");
  const issuerLink =
    "/resources/auditorsearch/issuers/?issuerid=" +
    getField(item, "issuerid") +
    "&issuercik=" +
    getField(item, "issuercik");
  const pdfLink = `/api/auditorsearch/downloadfiling?ID=${getField(
    item,
    "filingid"
  )}&filename=${issuerName && issuerName.replace(/[^\w\s]/gi, "")}_${moment(
    getField(item, "filingdate"),
    dateParsingFormat
  ).format("MMM DD YYYY")}.pdf`;
  return (
    <div>
      <div className="hawk-results-hero">
        <h3 className="hawk-results-hero__title">
          {getField(item, "issuerid") && issuerCik ? (
            <a href={issuerLink}>{issuerName}</a>
          ) : (
            <div>{issuerName}</div>
          )}
        </h3>
        <div className="hawk-results-hero__footer">
          <div className="hawk-results-hero__footer-top">
            <ul>
              <li>Issuer</li>
              {issuerCikExists && (
                <li>{`CIK ${padZerosToString(issuerCik)}`}</li>
              )}
              {issuerTicker && <li>{`Ticker ${issuerTicker}`}</li>}
            </ul>
            <div className="hawk-results-hero__footer-pdf-cta">
              <a className="hawk-download-pdf" target="_blank" href={pdfLink}>
                view completed form
              </a>
            </div>
          </div>
          <hr />
          <ul className="hawk-results-hero__footer-bottom">
            <li>
              <div className="form-details__label">Form AP Filing Date:</div>
              <div className="form-details__value">
                {moment(getField(item, "filingdate"), dateParsingFormat).format(
                  formatDate(getField(item, "filingdate"))
                )}
              </div>
            </li>
            <li>
              <div className="form-details__label">
                Financial Statement Year:
              </div>
              <div className="form-details__value">
                {getField(item, "filingaudityear") &&
                  getField(item, "filingaudityear")
                    .replace("+000000000000", "")
                    .replace(".0000", "")}
              </div>
            </li>
            <li>
              <div className="form-details__label">Engagement Partner:</div>
              <a className="form-details__value" href={engagementLink}>
                {getField(item, "engagementpartnername")}
              </a>
            </li>
            <li>
              <div className="form-details__label">Firm: </div>
              <a className="form-details__value break-word" href={firmLink}>
                {getField(item, "firmname")} ({getField(item, "firmid")})
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="hawk-results__detail">
        <div className="form-card">
          <h2>Identity Of Firm</h2>
          <strong>
            <p className="break-word">{getField(item, "firmname")}</p>
          </strong>
          {getField(item, "firmothername") && (
            <p>{`Legal Name: ${getField(item, "firmothername")}`}</p>
          )}
        </div>

        {getField(item, "amendmentpreviousfiling") === "True" && (
          <Amendments item={item} />
        )}

        <AuditClientAndReport item={item} />

        {getField(item, "isauditnotdivided") === "True" && (
          <ResponsibilityNotDivided item={item} />
        )}

        {getField(item, "isauditdivided") === "True" && (
          <ResponsibilityDivided item={item} />
        )}
      </div>
    </div>
  );
}
